import React, { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Chip,
} from '@mui/material';
import HandymanIcon from '@mui/icons-material/Handyman';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VerifiedIcon from '@mui/icons-material/Verified';

const ServiceItem = ({ service, defaultExpanded }) => {
  const [expanded, setExpanded] = useState(defaultExpanded || false);

  return (
    <Box
      sx={{
        border: '1px solid #E5E7EB',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        onClick={() => setExpanded(!expanded)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          cursor: 'pointer',
          '&:hover': { bgcolor: '#F9FAFB' },
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', color: '#1B2A3D' }}>
          {service.title}
        </Typography>
        <IconButton size="small">
          <ExpandMoreIcon
            sx={{
              fontSize: 20,
              transform: expanded ? 'rotate(180deg)' : 'none',
              transition: 'transform 0.2s',
            }}
          />
        </IconButton>
      </Box>

      <Collapse in={expanded}>
        <Box sx={{ px: 2, pb: 2, pt: 0 }}>
          <Typography sx={{ fontSize: '0.75rem', color: '#9CA3AF', mb: 1 }}>
            {service.date}
          </Typography>
          <Typography sx={{ fontSize: '0.8125rem', color: '#4B5563', mb: 1.5 }}>
            {service.details}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CheckCircleOutlineIcon sx={{ fontSize: 16, color: '#399432' }} />
            <Typography sx={{ fontSize: '0.75rem', color: '#6B7280' }}>
              {service.status}
            </Typography>
            <Chip
              icon={<VerifiedIcon sx={{ fontSize: '14px !important', color: '#399432 !important' }} />}
              label={service.approvedBy}
              size="small"
              variant="outlined"
              sx={{
                height: 24,
                fontSize: '0.6875rem',
                fontWeight: 500,
                borderColor: '#D1D5DB',
                ml: 0.5,
              }}
            />
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
};

const ServiceHistory = ({ services }) => {
  return (
    <Card sx={{ borderRadius: 1, flex: 1 }}>
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <HandymanIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          <Typography sx={{ fontWeight: 700, fontSize: '1rem', color: 'text.primary' }}>
            Service History
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {services.map((service, index) => (
            <ServiceItem
              key={service.id}
              service={service}
              defaultExpanded={index === 0}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceHistory;
